import { useGetStrings } from "@app/store/service/cmsService"
import { useGetOrder } from "@app/store/service/connectorService"
import { ORDER_LINE_TYPES } from "@app/utils/constants"
import { getDateString, getPriceString } from "@app/utils/localeUtils"
import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useViewport } from "@tecreation/funnel-components"
import { useEffect, useState } from "react"
export const MyParadiseOrderDetail = ({ webToken }) => {
	const { data: order } = useGetOrder({ webToken })
	const { data: strings } = useGetStrings()
	const [sortedOrder, setSortedOrder] = useState([])
	const { sm } = useViewport()
	const { labelEmail, labelDate, labelCode, labelTotal, labelPaymentMethod, labelProduct, numberShort, voucherStatus, labelOrderStatus } = strings
		? strings
		: {}

	useEffect(() => {
		if (order) {
			let tickets = []
			let loungers = []
			let other = []
			order.orderLines.forEach(temp => {
				if (temp.typeId === ORDER_LINE_TYPES.Ticket) {
					tickets.push(temp)
				} else if (temp.typeId === ORDER_LINE_TYPES.Object || temp.typeId === ORDER_LINE_TYPES.ObjectGroup) {
					loungers.push(temp)
				} else {
					if (temp.typeId === ORDER_LINE_TYPES.Account && temp.eft) {
						//ignore Account Lines with an eft because that is a paymentLine and we dont want to show that
					} else {
						other.push(temp)
					}
				}
			})
			tickets.sort((a, b) => {
				return a.id - b.id
			})
			loungers.sort((a, b) => {
				return a.id - b.id
			})
			other.sort((a, b) => {
				return a.id - b.id
			})
			let tempArr = [...tickets, ...loungers, ...other]
			setSortedOrder(tempArr)
		}
	}, [order])

	return order ? (
		<div className="w-100 color-fg-default">
			<div>
				<div className={"w-100 flex flex-justify-between mb-1 " + sm && "flex-column"}>
					<div>
						<span>{labelOrderStatus}: </span>
						{order.processed ? "Processed" : "Proccessing"}
					</div>
					<div className="pr-5 mt-1">
						<span>{labelEmail}: </span> {order.relation.email}
					</div>
				</div>
				<div className="mb-1 mt-1">
					<span>{labelDate}: </span>
					{getDateString(new Date(order.orderDate))}
				</div>
				<div className="mb-1">
					<span>{labelTotal}: </span>
					{getPriceString(order.payAmount)}
				</div>
				<div>
					<span>{labelPaymentMethod}: </span>
					{order.paymentMethod}
				</div>
			</div>
			<div className="mt-6 mb-4">
				<h2 className="mb-2">{labelProduct}:</h2>
				{sortedOrder
					.filter(e => e.typeId != ORDER_LINE_TYPES.Payment)
					.map((e, i) => (
						<div key={i} className="color-fg-default mb-2 mt-2">
							<span className="mr-2 f5 bold">{e.quantity + "x "}</span>{" "}
							<span className="bold f5">{e.details[0].translation ? e.details[0].translation + " " : e.details[0].description + " "}</span>
							{e.details[0].scanCode && e.typeId !== ORDER_LINE_TYPES.Object && e.details[0].visitorKindId !== 3 && (
								<span className="color-fg-secondary regular ml-2" style={{ fontStyle: "italic" }}>
									<span className="color-fg-default">{labelCode}:</span>{" "}
									{typeof e.details[0].scanCode == "string" ? e.details[0].scanCode : JSON.stringify(e.details[0].scanCode)}
									{e.details[0].status ? (
										<>
											<span className="color-fg-default ml-2">Status: </span>
											{voucherStatus?.find(f => f.value === e.details[0].status)?.name}
										</>
									) : (
										""
									)}
								</span>
							)}
							{(e.typeId === ORDER_LINE_TYPES.Object || e.typeId === ORDER_LINE_TYPES.ObjectGroup) && (
								<span className="ml-2">
									{numberShort}{" "}
									<span className="color-fg-secondary">
										{e.details[0].zoneAbbreviation}-{e.details[0].abbreviation}
										{e.details[0].objectNumber || e.details[0].number}
									</span>
								</span>
							)}
						</div>
					))}
			</div>
		</div>
	) : (
		<div className="w-100 flex flex-column flex-items-center color-fg-default" style={{ minHeight: "120px" }}>
			<FontAwesomeIcon size="xl" icon={faSpinner} spin />
		</div>
	)
}
